import React, { useEffect, useRef, useState } from "react";

import { signOut, getAuth } from "firebase/auth";

import NavBar from "./navbar";
import { UserRole, hasAnyRole, useAuth } from "../../context/AuthContext";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Members from "../members";
import Channels from "../channels";
import Analytics from "../analytics";
import Artifact from "../artifacts";
import Onboarding from "../onboarding";
import { NavBarProvider } from "../../context/NavigationContext";
import Payments from "../payments";
import { Link } from "react-router-dom";
import ContentModerator from "../contentModeration";
import ChannelModeration from "../channelManagement";
import { WidgetShowcase } from "../WidgetShowcase";
import ProtectedRoutes from "../routes/ProtectedRoute";
import ProtectedDashboardRoutes from "./ProtectedDashboardRoute";
import PageNotFound from "../pageNotFound";
import Home from "./Home";
import InviteList from "./InviteList";
import { capitalizeFirstLetter } from "../../utils/stringFunctions";
import AccountSetting from "../accountSettings";
import { ChannelState, ChannelSubstate } from "../../models/SKChannel";
import ConditionalNavigation from "./conditionalNavigation";
import Settings from "../channels/Settings";
import { LeftbarProvider, useLeftbarBar } from "../../context/LeftSidebarContext";
import UserFeedback from "../userFeedback";
import ListApplications from "../applicationModeration/listApplication";
import Application from "../applicationModeration";
import packageJson from "../../../package.json";

const roles = [
  { title: "Skarvo Admin", value: UserRole.SkarvoAdmin },
  { title: "Skarvo Operator", value: UserRole.SkarvoOperator },
  { title: "Creator Admin", value: UserRole.CreatorAdmin },
  { title: "Brand Admin ", value: UserRole.BrandAdmin },
  { title: "Operator", value: UserRole.Operator },
  { title: "Skarvo Channel Moderator", value: UserRole.SkarvoChannelModerator },
  { title: "Skarvo Content Operator", value: UserRole.SkarvoContentModerator },
];

const Index = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const popupRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setIsDropdownOpen(false);
    }
  };

  let context = useAuth();
  let auth = getAuth();
  // Function to toggle sidebar visibility

  // useEffect(() => {
  //   if(!context) return
  //   context.userRoles && context.userRoles.length > 0 ? (
  //     <Navigate to="/dashboard/home" />
  //   ) : context.myInvites && context.myInvites.length > 0 ? (
  //     <Navigate to="/dashboard/invitelist" />
  //   ) : (

  //   );
  // }, [context]);

  // useEffect(() => {
  //   if (context?.userRoles && context.userRoles.length > 0) {
  //     if (context && !context.myChannel) {
  //       if (context && context.myInvites && context.myInvites.length > 0) {
  //         return navigate("./invitelist");
  //       } else {
  //         return navigate("./channels/onboarding");
  //       }
  //     } else if (context.myChannel) {
  //       return navigate("./channels");
  //     }
  //   }
  // }, [context]);

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="relative flex flex-col h-screen mx-auto overflow-hidden md:max-w-full">
      <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 md:left-1/2 md:transform md:-translate-x-1/2 md:w-full dark:bg-gray-800 dark:border-gray-700">
        <div className="px-3 py-3 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start rtl:justify-end">
              <Link to={"/dashboard/home"} className="flex ms-2 md:me-24">
                <span className="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white">Skarvo Business</span>
              </Link>
            </div>
            <div className="flex items-center">
              <div className="relative flex items-center ms-3">
                <div className="flex flex-row items-center">
                  <button
                    type="button"
                    onClick={toggleDropdown}
                    className="flex text-sm bg-white rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                    aria-expanded={false}
                    data-dropdown-toggle="dropdown-user"
                  >
                    <img className="w-5 h-5 rounded-full" src={context?.currentUser?.photoURL ?? "/icons/Profile.png"} alt="user acccount" />
                  </button>
                  <div className="flex flex-col">
                    <span className="ml-2 text-sm font-semibold hover:cursor-pointer" onClick={toggleDropdown}>
                      {context?.currentUser?.displayName}
                    </span>
                    <span className="text-skgray text-[10px] ml-2 hover:cursor-pointer" onClick={toggleDropdown}>
                      {context?.userRoles && Array.isArray(context?.userRoles) && context?.userRoles[0]
                        ? roles.find(obj => obj.value === context?.userRoles![0])?.title ?? ""
                        : ""}
                    </span>
                  </div>
                </div>
                <div
                  ref={popupRef}
                  className={`absolute right-[50px] mt-2 w-48 pt-[130px] z-[1000] ${
                    isDropdownOpen ? "block" : "hidden"
                  } my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600`}
                  id="dropdown-user"
                >
                  <div>
                    <div className={" flex items-center p-2 pt-4 dark:text-white "}>
                      <span className="px-2 text-sm text-gray-400">Version {packageJson.version}</span>
                    </div>
                  </div>
                  <div className="px-4 py-3" role="none">
                    <p className="text-sm text-gray-900 dark:text-white" role="none">
                      {capitalizeFirstLetter(context?.currentUser?.displayName ?? "")}
                    </p>
                    <p className="text-sm font-medium text-gray-900 truncate dark:text-gray-300" role="none">
                      {context?.currentUser?.email}
                    </p>
                  </div>
                  <ul className="py-1" role="none">
                    <li>
                      <Link
                        to="accountSettings"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                        role="menuitem"
                      >
                        Account Settings
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={"#"}
                        onClick={e => {
                          e.preventDefault();
                          signOut(auth);
                        }}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                        role="menuitem"
                      >
                        Log out
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className="relative flex flex-col flex-1 w-full md:flex-row mt-14">
        {context?.userRoles &&
        (hasAnyRole(context?.userRoles, [UserRole.BrandAdmin, UserRole.CreatorAdmin])
          ? context.myChannel &&
            (context.myChannel.status === ChannelState.ACTIVE ||
              context.myChannel.status === ChannelState.IN_REVIEW ||
              (context.myChannel.status === ChannelState.DRAFT && context.myChannel.subStatus !== ChannelSubstate.NONE))
          : hasAnyRole(context?.userRoles, [
              UserRole.SkarvoAdmin,
              UserRole.SkarvoChannelModerator,
              UserRole.SkarvoContentModerator,
              UserRole.SkarvoOperator,
            ])
          ? true
          : false) ? (
          <NavBar />
        ) : (
          ""
        )}

        <div className="flex-1 overflow-hidden clear-start ml-[20px] mt-[30px] mr-[20px]">
          <NavBarProvider>
            <Routes>
              <Route path="/" element={<ConditionalNavigation />} />
              <Route path="/home" element={<Home />} />

              <Route path="/channels/*" element={<Channels />} />

              <Route path="/invitelist" element={<InviteList />} />
              <Route path="/pagenotfound" element={<PageNotFound />} />

              <Route element={<ProtectedDashboardRoutes allowedRoles={[UserRole.CreatorAdmin, UserRole.SkarvoAdmin]} />}>
                <Route path="/members/*" element={<Members />} />
              </Route>
              <Route element={<ProtectedDashboardRoutes allowedRoles={[UserRole.CreatorAdmin, UserRole.BrandAdmin, UserRole.Operator]} />}>
                <Route path="/content/*" element={<Artifact />} />
              </Route>

              <Route path="/analytics" element={<Analytics />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/payment" element={<Payments />} />
              <Route
                element={<ProtectedDashboardRoutes allowedRoles={[UserRole.SkarvoAdmin, UserRole.SkarvoContentModerator, UserRole.SkarvoOperator]} />}
              >
                <Route path="/contentModeration/*" element={<ContentModerator />} />
              </Route>
              <Route
                element={<ProtectedDashboardRoutes allowedRoles={[UserRole.SkarvoAdmin, UserRole.SkarvoChannelModerator, UserRole.SkarvoOperator]} />}
              >
                <Route path="/channelModeration/*" element={<ChannelModeration />} />
              </Route>
              <Route
                element={<ProtectedDashboardRoutes allowedRoles={[UserRole.SkarvoAdmin, UserRole.SkarvoChannelModerator, UserRole.SkarvoOperator]} />}
              >
                <Route path="/userFeedback/*" element={<UserFeedback />} />
                <Route path="/applications/*" element={<Application />} />
              </Route>
              <Route path="/widgetShowcase/*" element={<WidgetShowcase />} />

              <Route path="/accountSettings/*" element={<AccountSetting />} />
            </Routes>
          </NavBarProvider>
        </div>
      </div>
    </div>
  );
};

export default Index;
